module.exports = "/_next/static/images/376a5cbb5dadd29460278bd082e70fc6-app-screenshots-md@3x.jpg";